import {useEffect, useState} from "react";
import BlogImagePopper from "./BlogImageLarge";
import zoomImg from "../../../../assets/icons/imgBtn.svg";
import image1 from "../../../../assets/images/blog25/blog25-1.png";
import image3 from "../../../../assets/images/blog25/blog25-3.png";
import image24 from "../../../../assets/images/blog25/blog25-24.png";
import image29 from "../../../../assets/images/blog25/blog25-29.png";
import image5 from "../../../../assets/images/blog25/blog25-5.png";
import image6 from "../../../../assets/images/blog25/blog25-6.png";
import image21 from "../../../../assets/images/blog25/blog25-21.png";
import image23 from "../../../../assets/images/blog25/blog25-23.png";
import image19 from "../../../../assets/images/blog25/blog25-19.png";
import image20 from "../../../../assets/images/blog25/blog25-20.png";
import image10 from "../../../../assets/images/blog25/blog25-10.png";
import image9 from "../../../../assets/images/blog25/blog25-9.png";
import image26 from "../../../../assets/images/blog25/blog25-26.png";
import image27 from "../../../../assets/images/blog25/blog25-27.png";
import image25 from "../../../../assets/images/blog25/blog25-25.png";
import image48 from "../../../../assets/images/blog25/blog25-48.png";
import image17 from "../../../../assets/images/blog25/blog25-17.png";
import image16 from "../../../../assets/images/blog25/blog25-16.png";
import image31 from "../../../../assets/images/blog25/blog25-31.png";
import image37 from "../../../../assets/images/blog25/blog25-37.png";
import image39 from "../../../../assets/images/blog25/blog25-39.png";
import image51 from "../../../../assets/images/blog25/blog25-51.png";
import image34 from "../../../../assets/images/blog25/blog25-34.png";
import image35 from "../../../../assets/images/blog25/blog25-35.png";
import image4 from "../../../../assets/images/blog25/blog25-4.png";

const Blog25 = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const handleRedirect = (url) => {
    window.open(url, "_blank");
  };
  const handleLargeImg = (img) => {
    setSelectedImage(img);
  };
  return (
    <div className="MainNewBlog">
      <div className="blogHeader">
        <h2 className="headerBoldText mainHeader">Weekly Market Outlook – June 30th, 2025</h2>
      </div>
      <div className="blogContentnew">
        <p>
          Markets defy gravity as liquidity surges, Fed signals remain mixed, and positioning remains cautious, but breadth continues to deteriorate. Here's your complete macro deep dive, technical
          setups, and trading forecast for the week ahead.
        </p>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Market Overview: ATHs with Narrow Breadth, Surging Liquidity, and FOMO Traps</p>
              <p>
                Markets charged into the final week of June with a powerful upside drift. The S&P 500 closed the week at all-time highs—but only <span className="highlightedText">22 stocks</span> in
                the index did the same. That kind of narrow leadership isn’t unusual at this stage in the cycle, but it does raise red flags for those watching participation breadth and institutional
                flows.
              </p>
            </div>
            <div className="contentDiv listOfRecap">
              <p>
                Traders looking for a pullback are getting steamrolled. With <span className="highlightedText">global M2 money supply</span> pushing higher and{" "}
                <span className="highlightedText">political risks being sidelined</span>, the path of least resistance remains up.
              </p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>VIX and MOVE are anchored at historically low levels</p>
                </li>
                <li className="themesPointer">
                  <p>HYG (high-yield bonds) has broken out—a clear risk-on tell</p>
                </li>
                <li className="themesPointer">
                  <p>The McClellan Oscillator remains in positive territory</p>
                </li>
                <li className="themesPointer">
                  <p>
                    Equity flows are being supported by a pickup in <span className="highlightedText">M&A and IPO activity</span>
                  </p>
                </li>
              </ul>
              <p>This isn’t a melt-up built on euphoria—yet. It’s being powered by liquidity, policy, and under-positioning.</p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image1}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image1)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image3}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image3)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image29}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image29)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image24}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image24)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv ">
            <div className="contentDiv">
              <p className="highlightedBoldText">Macro & Policy Watch: Shadow Fed, Trump’s Tax Clock, and Dollar Dump Dynamics</p>
            </div>
            <p
              style={{
                textAlign: "justify",
                fontFamily: "var(--header-font-family)",
                fontSize: "18px",
                fontStyle: "normal",
                fontWeight: 600,
                lineHeight: "30px",
                color: "#010310",
              }}
            >
              Powell Pushback vs Political Pressure
            </p>
            <p>
              Last week, Powell and other Fed officials tried to throw cold water on July rate cut speculation—but the market didn’t fully buy it. With former Trump appointees like {""}
              <span className="highlightedText">Waller and Bowman </span>
              floating July cuts, the Fed's independence is under scrutiny. Even as Powell reasserts control, the idea of a <span className="highlightedText">“Shadow Fed Chief”</span> remains a
              looming political risk.
            </p>

            <p
              style={{
                textAlign: "justify",
                fontFamily: "var(--header-font-family)",
                fontSize: "18px",
                fontStyle: "normal",
                fontWeight: 600,
                lineHeight: "30px",
                color: "#010310",
              }}
            >
              Rate Cuts: When, Not If
            </p>
            <p>
              Markets aren't necessarily reacting to dovish rhetoric—they’re front-running what seems inevitable.<span className="highlightedText"> G10 yields are falling</span>,
              <span className="highlightedText"> global inflation is easing</span>, and <span className="highlightedText">M2 is rising</span>. The current Fed speak may delay action, but traders
              believe it won’t change the outcome.
            </p>

            <div className="contentDiv listOfRecap">
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    The <span className="highlightedText">U.S. Dollar</span> is in freefall, marking one of its worst stretches in years
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Rate differentials</span> no longer support the greenback
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Liquidity</span> is rising faster than inflation
                  </p>
                </li>
              </ul>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image5}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image5)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image6}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image6)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image21}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image21)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image23}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image23)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <p
              style={{
                textAlign: "justify",
                fontFamily: "var(--header-font-family)",
                fontSize: "18px",
                fontStyle: "normal",
                fontWeight: 600,
                lineHeight: "30px",
                color: "#010310",
              }}
            >
              Outside the U.S.: Reflation vs Stimulus Watch
            </p>

            <div className="contentDiv listOfRecap">
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Germany’s PMI</span> surprised to the upside, sparking hopes of a reflationary turnaround in Europe
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    Meanwhile, <span className="highlightedText">China’s corporate profits</span> continue to disappoint, keeping the door open for a fresh round of stimulus out of Beijing
                  </p>
                </li>
              </ul>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image19}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image19)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image20}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image20)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <p>
              Bottom line: The market is pricing in easing, regardless of central bank rhetoric. The Fed may still hold in July, but expectations for a{" "}
              <span className="highlightedText"> September pivot</span> are building.
            </p>
          </div>
        </div>

        <hr className="divisionLine" />

        <div className="subHeader">
          <div className="contentDivWrapper flexDiv">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Technical & Sentiment Breakdown: Seasonality, Gamma Exposure & Option Frenzy</p>
              <p
                style={{
                  textAlign: "justify",
                  fontFamily: "var(--header-font-family)",
                  fontSize: "18px",
                  fontStyle: "normal",
                  fontWeight: 600,
                  lineHeight: "30px",
                  color: "#010310",
                }}
              >
                Seasonality Tailwinds Remain Intact
              </p>
              <p>
                Statistically, <span className="highlightedText">July’s first half </span> is one of the strongest stretches for equities. When June closes strong—as it did this year—July tends to
                continue the trend. Add a lack of fear, rising gamma levels, and light positioning, and the melt-up narrative gains legs.
              </p>
            </div>
            <div className="contentDiv listOfRecap">
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image10}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image10)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image9}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image9)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image26}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image26)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p
                style={{
                  textAlign: "justify",
                  fontFamily: "var(--header-font-family)",
                  fontSize: "18px",
                  fontStyle: "normal",
                  fontWeight: 600,
                  lineHeight: "30px",
                  color: "#010310",
                }}
              >
                Key Technical Signals
              </p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    The <span className="highlightedText">Nasdaq just triggered a Golden Cross</span>, echoing the March 2023 signal that preceded an 82% rally
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Gamma exposure</span> is now stacked around <span className="highlightedText">SPX 6200</span>, while{" "}
                    <span className="highlightedText">Max Pain sits at 6100</span>
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">0DTE options volumes</span> remain sky-high, amplifying intraday volatility and dealer hedging dynamics
                  </p>
                </li>
                <li className="themesPointer">
                  <p>Momentum is still building—SPX looks primed for a breakout continuation</p>
                </li>
              </ul>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image27}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image27)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image25}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image25)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image48}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image48)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Last Week’s Recap: Powell Holds the Line, Housing Cracks, and Crypto Lifts Off</p>
              <p>Markets absorbed a key week of Fed speeches, inflation data, and macro signals:</p>
            </div>
            <div className="contentDiv listOfRecap">
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    {" "}
                    <span className="highlightedText">Core PCE</span> came in at +2.7% YoY—above expectations
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    {" "}
                    <span className="highlightedText">Real incomes and consumption</span> declined
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Continuing claims </span>
                    climbed, signalling softening in labour markets
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    {" "}
                    <span className="highlightedText">Pending home sales </span>were stronger, but under the surface, housing continues to slide
                  </p>
                </li>
              </ul>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image17}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image17)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image16}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image16)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <p>In the commodity space:</p>

            <div className="contentDiv listOfRecap">
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    {" "}
                    <span className="highlightedText">Gold</span> sold off for a second straight week, despite steady central bank demand
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    {" "}
                    <span className="highlightedText">Oil</span> dropped 13%—its worst weekly decline since March 2023
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Bitcoin </span>
                    surged, helped by a ruling that allows crypto to be used as collateral for U.S. mortgages via the FHFA
                  </p>
                </li>
              </ul>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image31}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image31)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image37}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image37)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image39}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image39)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">The Week Ahead: “Big Thursday, Global Panels, and Critical Payroll Clues”</p>
              <p>A U.S. holiday-shortened week, but Thursday is absolutely stacked. Expect volatility.</p>

              <p className="highlightedText">Monday, June 30</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p className="highlightedText">GER CPI Flash (June)</p>
                </li>
                <li className="themesPointer">
                  <p className="highlightedText">CNY PMIs</p>
                </li>
                <li className="themesPointer">
                  <p className="highlightedText">GBP Final Q1 GDP</p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Fed speakers:</span> Bostic, Goolsbee
                  </p>
                </li>
              </ul>

              <p className="highlightedText">Tuesday, July 1</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Powell, Lagarde, Bailey, Ueda</span> share a panel at the <span className="highlightedText">ECB Forum in Lisbon</span>
                  </p>
                </li>
                <li className="themesPointer">
                  <p className="highlightedText">ISM Manufacturing</p>
                </li>
                <li className="themesPointer">
                  <p className="highlightedText">JOLTS Job Openings</p>
                </li>
                <li className="themesPointer">
                  <p className="highlightedText">Atlanta GDPNow update</p>
                </li>
              </ul>

              <p className="highlightedText">Wednesday, July 2</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p className="highlightedText">ADP Employment</p>
                </li>
                <li className="themesPointer">
                  <p className="highlightedText">Challenger Job Cuts</p>
                </li>
                <li className="themesPointer">
                  <p className="highlightedText">Eurozone Unemployment</p>
                </li>
              </ul>

              <p className="highlightedText">Thursday, July 3 (U.S. Early Close)</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p className="highlightedText">Nonfarm Payrolls (NFP)</p>
                </li>
                <li className="themesPointer">
                  <p className="highlightedText">ISM Services</p>
                </li>
                <li className="themesPointer">
                  <p className="highlightedText">Jobless Claims</p>
                </li>
                <li className="themesPointer">
                  <p className="highlightedText">U.S. Trade Balance</p>
                </li>
              </ul>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image51}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image51)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>

              <p className="highlightedText">Friday, July 4 (Markets Closed)</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p className="highlightedText">EZ PPI</p>
                </li>
                <li className="themesPointer">
                  <p className="highlightedText">JPY Household Spending</p>
                </li>
                <li className="themesPointer">
                  <p className="highlightedText">CHF Unemployment</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />

        <div className="subHeader">
          <div className="contentDivWrapper flexDiv">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Alpha Takeaway: Melt-Up Isn’t Mania—Yet</p>
              <p>Risk assets are rallying, but we’re not yet in euphoric territory:</p>

              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>Positioning remains cautious</p>
                </li>
                <li className="themesPointer">
                  <p>Liquidity is driving flows</p>
                </li>
                <li className="themesPointer">
                  <p>Technicals are bullish</p>
                </li>
                <li className="themesPointer">
                  <p>Geopolitical risks are priced in</p>
                </li>
                <li className="themesPointer">
                  <p>Fed credibility is being tested</p>
                </li>
              </ul>

              <p>Stay long into strength, but be ready to pivot if CPI or NFP surprises to the upside. Until then, the market wants to go higher.</p>

              <p className="highlightedText">Our Stance:</p>

              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>Stay long SPX, especially above 6100</p>
                </li>
                <li className="themesPointer">
                  <p>Use dips for entries in Gold & Crypto</p>
                </li>
                <li className="themesPointer">
                  <p>Watch EM and defensive rotation</p>
                </li>
                <li className="themesPointer">
                  <p>Do not fade this move—yet.</p>
                </li>
              </ul>
            </div>
            <div className="imageWrapperCont">
              <div className="relatedImg">
                <img
                  src={image34}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image34)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
              <div className="relatedImg">
                <img
                  src={image35}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image35)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>

              <div className="relatedImg">
                <img
                  src={image4}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image4)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="button_wrapper">
          <button
            className="gradientButton_small "
            onClick={() => {
              handleRedirect("https://docs.google.com/document/d/1hnd42j1nmQcnTVzDLMNewt5ESoHtIQc_ROefGYIbaaE/edit?tab=t.0");
            }}
          >
            Read In-Depth Market Outlook
          </button>
        </div>
      </div>
      {selectedImage && (
        <BlogImagePopper
          image={selectedImage}
          onClose={() => handleLargeImg(null)}
        />
      )}
    </div>
  );
};

export default Blog25;
